import { Stack, Typography, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import InfoIcon from "@mui/icons-material/Info";
import { formatFileSize } from "../../../utils";

export const TemplateUploadSection = ({
  file,
  onChange,
  fileRef,
  acceptedInput = ".xls,.xlsx",
}) => {
  return (
    <Stack gap="4px">
      <Stack backgroundColor="background.default" padding="8px" gap="6px">
        <Typography fontSize="12px" fontWeight={600} px="8px">
          Import File
        </Typography>
        <Stack
          borderRadius="6px"
          backgroundColor="background.paper"
          border={1}
          borderColor="divider"
          alignItems="center"
          justifyContent="space-between"
          gap="8px"
          flexDirection="row"
          flexWrap="wrap"
          px="16px"
          py="8px"
          height="56px"
        >
          {file ? (
            <>
              <Stack
                flexDirection="row"
                gap="16px"
                alignItems="center"
                flex="1"
              >
                <img alt="file" src="/icons/ic_file.jpg" />
                <Stack>
                  <Typography
                    fontSize="12px"
                    fontWeight={500}
                    sx={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      flexGrow: 1,
                      width: { md: "300px", xs: "150px" },
                    }}
                    title={file?.name}
                  >
                    {file?.name}
                  </Typography>
                  <Typography fontSize="11px">
                    {formatFileSize(file.size)}
                  </Typography>
                </Stack>
              </Stack>
              <Button size="small" color="error" onClick={() => onChange()}>
                Remove
              </Button>
            </>
          ) : (
            <Button
              variant="text"
              startIcon={<AddIcon />}
              component="label"
              size="small"
            >
              Add File
              <input
                id="contained-button-file"
                type="file"
                accept={acceptedInput}
                onChange={onChange}
                onClick={(e) => {
                  e.target.value = null;
                }}
                style={{ display: "none" }}
                ref={fileRef}
              />
            </Button>
          )}
        </Stack>
      </Stack>
      <Stack flexDirection="row" alignItems="center" gap="4px">
        <InfoIcon sx={{ fontSize: 16, color: "neutral.35" }} />
        <Typography color="neutral.35" fontSize="14px" fontWeight={400}>
          Supported format: .xlsx
        </Typography>
      </Stack>
    </Stack>
  );
};
